var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.7855,
    cy: 30.8485,
    r: 30.5741,
    fill: "#4C4D52"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2273 21.8564H21.3433C20.1017 21.8564 19.0952 22.863 19.0952 24.1045V37.5931C19.0952 38.8347 20.1017 39.8412 21.3433 39.8412H40.2273C41.4689 39.8412 42.4754 38.8347 42.4754 37.5931V24.1045C42.4754 22.863 41.4689 21.8564 40.2273 21.8564Z",
    stroke: "#33B1E9",
    strokeWidth: 1.79848,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6919 25.4531L30.785 31.7478L38.8782 25.4531",
    stroke: "#33B1E9",
    strokeWidth: 1.79848,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.6309eb8e493f413c61ab614583898eb6.svg";
export { ForwardRef as ReactComponent };